export const SIDEBAR_WIDTH = 280;
export const ACCOUNT_DRAWER_WIDTH = 320;
